export function createPrimaryKey(interbullNumber: string, color: string, type: string): string {
    return `${interbullNumber}-${color}-${type}`
}